<template>
  <BaseDialog
    :title="title ? title : ''"
    v-model="openExcelDownloadDialog"
    :btnEnable="true"
    width="800"
    :eager="eager"
    cardTextClass="px-4 pt-4"
    @reset="resetDownloadForm"
  >
    <template #information>
      <v-form v-model="isDownloadValid" ref="downloadValid">
        <v-row>
          <v-col cols="4" v-if="module == 'items'">
            <v-alert border="left" colored-border type="info">
              By default, all storage types will be selected if no storage type
              is selected.
            </v-alert>
          </v-col>
          <v-col
            cols="6"
            lg="3"
            v-if="
              module == 'orderNew' ||
              module == 'driver' ||
              module == 'vehicle' ||
              module == 'customerAddress' ||
              module == 'customer'
            "
          >
            <SelectField
              :itemsList="branchList"
              itemText="name"
              hide-details="auto"
              :multiple="true"
              itemValue="id"
              label="select Branch"
              v-model="filters.branch"
              :dense="true"
            />
          </v-col>
          <v-col cols="6" lg="3" v-if="module == 'orderNew'">
            <SelectField
              :itemsList="orderSegmentList"
              hide-details="auto"
              itemText="display_value"
              itemValue="value"
              label="Order Segment *"
              v-model="filters.segment"
              :rules="[(val) => !!val || 'Order Segment is required']"
              :dense="true"
            />
          </v-col>
          <v-col
            cols="6"
            lg="3"
            v-if="module == 'vehicleTags' || module == 'tag'"
          >
            <SelectField
              :itemsList="vehicleList"
              hide-details="auto"
              :multiple="true"
              itemText="vehicle_number"
              itemValue="id"
              label="select Vehicle"
              v-model="filters.vehicle"
              :dense="true"
            />
          </v-col>
          <v-col cols="6" lg="3" v-if="module == 'orderNew'">
            <DatePicker
              outlined
              type="date"
              dense
              required
              hide-details="auto"
              :rules="[(v) => !!v || 'From data is required']"
              name="from_date"
              label="from date*"
              v-model="filters.from_date"
              @input="onStartDateChangeValidation"
            />
          </v-col>
          <v-col cols="6" lg="3" v-if="module == 'orderNew'">
            <DatePicker
              :min="filters.from_date"
              outlined
              type="date"
              dense
              required
              hide-details="auto"
              :rules="[(v) => !!v || 'To date is required']"
              name="to_date"
              label="to date*"
              @change="onEndDateChange"
              v-model="filters.to_date"
            />
          </v-col>
          <v-col cols="6" lg="3" v-if="module == 'orderNew'">
            <SelectField
              :isSearchRequired="false"
              :itemsList="orderStatusList"
              label="select status*"
              itemText="display_value"
              hide-details="auto"
              itemValue="value"
              required
              :multiple="true"
              :rules="[(v) => (!!v && v.length > 0) || `Status is required`]"
              :dense="true"
              class="background-white"
              v-model="filters.status"
            />
          </v-col>
          <v-col cols="6" lg="3" v-if="module == 'customerAddressTags'">
            <SelectField
              :itemsList="customerAddressList"
              itemText="location_id"
              :multiple="true"
              itemValue="id"
              label="select customer Address "
              v-model="filters.customer_address"
              :dense="true"
            />
          </v-col>
          <v-col
            cols="6"
            lg="4"
            v-if="module == 'customerAddress' || module == 'tag'"
          >
            <SelectField
              :itemsList="customerList"
              itemText="code"
              :multiple="true"
              itemValue="id"
              label="select customer"
              v-model="filters.customer__in"
              :dense="true"
            />
          </v-col>
          <v-col
            cols="6"
            lg="3"
            v-if="module == 'customerAddress' || module == 'vehicle'"
          >
            <SelectField
              :itemsList="vehicleTagsList"
              itemText="name"
              :multiple="true"
              itemValue="id"
              hide-details="auto"
              label="select tag"
              v-model="filters.tag"
              :dense="true"
            />
          </v-col>
          <v-col ols="6" lg="3" v-if="module == 'driver'">
            <SelectField
              :itemsList="zoneList"
              itemText="name"
              :multiple="true"
              itemValue="id"
              label="select zone"
              v-model="filters.zone"
              :dense="true"
            />
          </v-col>
          <v-col cols="6" lg="4" v-if="module == 'item'">
            <SelectField
              dense
              clearable
              v-model="filters.storage_type"
              :itemsList="storageType"
              hide-details="auto"
              itemText="display_value"
              itemValue="value"
              label="select storage type"
              outlined
              :menu-props="{ offsetY: true }"
            >
            </SelectField>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #action>
      <v-spacer></v-spacer>
      <v-row no-gutters>
        <v-col cols="12" class="text-right">
          <PrimaryButton
            class="primary"
            :disabled="!isDownloadValid"
            @click="getExportData()"
            name="Export"
          >
          </PrimaryButton>
        </v-col>
      </v-row>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import { bus } from "@/main";
import { downloadBlob, returnToday } from "@/utils/functions";

export default {
  components: {
    BaseDialog,
  },
  props: {
    value: {
      required: true,
    },
    title: {
      required: true,
    },
    module: {
      required: true,
    },
    method: {
      required: true,
    },
    eager: {
      default: false,
    },
  },
  data() {
    return {
      filters: {
        limit: "all",
      },
      branchList: [],
      orderStatusList: [],
      storageType: [],
      zoneList: [],
      isDownloadValid: false,
      vehicleTagsList: [],
      vehicleList: [],
      customerList: [],
      customerAddressList: [],
      orderSegmentList: [],
    };
  },
  watch: {
    openExcelDownloadDialog(val) {
      if (val) {
        if (this.module != "item") {
          this.getBranchList();
        }
        if (this.module == "item") {
          this.getItemOptions();
        } else if (this.module == "driver") {
          this.getZoneList();
        } else if (this.module == "vehicle") {
          this.getVehicleTagList();
        } else if (this.module == "vehicleTags") {
          this.getVehicleList();
        } else if (this.module == "customerAddress") {
          this.getVehicleTagList();
          this.getCustomerList();
        } else if (this.module == "customerAddressTags") {
          this.getCustomerAddressList();
        } else if (this.module == "tag") {
          this.getCustomerList();
          this.getVehicleList();
        }
        this.getOrderOptions();
      }
    },
  },
  computed: {
    openExcelDownloadDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getOrderOptions() {
      this.$api.orderNew
        .getOrderOptions({ request_type: "filter" })
        .then((res) => {
          this.orderStatusList = res?.data?.status;
          this.orderSegmentList = res.data.segment;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getItemOptions() {
      this.$api.item
        .getItemOptions({ request_type: "filter" })
        .then((res) => {
          this.storageType = res?.data?.storage_type;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onEndDateChange(endDate) {
      let today = new Date(endDate);
      if (today.getDate() > 15) {
        bus.$emit("showToastMessage", {
          message: "maximum of 15 day' worth of data can be retrieved",
          color: "error",
        });
        this.filters = {
          ...this.filters,
          to_date: null,
        };
      }
    },
    onStartDateChangeValidation() {
      let selectedDate = new Date(this.filters.from_date);
      selectedDate.setDate(selectedDate.getDate() + 14);
      this.filters = {
        ...this.filters,
        to_date: selectedDate,
      };
      this.filters.to_date = selectedDate.toISOString().slice(0, 10);
      this.getCheckMonthDifference();
    },
    getCheckMonthDifference() {
      if (this.filters && this.filters.from_date && this.filters.to_date) {
        const date1 = new Date(this.filters.from_date);
        const date2 = new Date(this.filters.to_date);
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays >= 15) {
          bus.$emit("showToastMessage", {
            message: "maximum of 15 day' worth of data can be retrieved",
            color: "error",
          });
          this.isValid = true;
          return false;
        } else {
          this.isValid = false;
          return true;
        }
      } else {
        this.isValid = false;
        return false;
      }
    },
    resetDownloadForm() {
      this.filters = {};
      this.filters.limit = "all";
      this.$refs.downloadValid.resetValidation();
      this.openExcelDownloadDialog = false;
    },
    getCustomerAddressList() {
      this.$api.customerAddress
        .getCustomerAddressSelectList({ limit: "all" })
        .then((res) => {
          this.customerAddressList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCustomerList() {
      this.$api.customer
        .getCustomerSelectList({ limit: "all" })
        .then((res) => {
          this.customerList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getVehicleList() {
      this.$api.vehicle
        .getVehicleSelectList({ limit: "all" })
        .then((res) => {
          this.vehicleList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getBranchList(params = {}) {
      this.$api.branch
        .getBranchList({ ...params, limit: "all" })
        .then((res) => {
          this.branchList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getVehicleTagList() {
      this.$api.tag
        .getTagList({ tag_type: "vehicle_tag", limit: "all" })
        .then((res) => {
          this.vehicleTagsList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getZoneList() {
      this.$api.driverZone
        .getDriverZoneSelectList({
          limit: "all",
        })
        .then((res) => {
          this.zoneList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getExportData(params = {}) {
      params = {
        ...params,
        ...this.filters,
      };

      if (params && params.customer__in && params.customer__in.length > 0) {
        params.customer__in = params.customer__in.join(",");
      }
      if (
        params &&
        params.customer_address &&
        params.customer_address.length > 0
      ) {
        params.customer_address = params.customer_address.join(",");
      }
      if (params && params.vehicle && params.vehicle.length > 0) {
        params.vehicle = params.vehicle.join(",");
      }
      if (params && params.tag && params.tag.length > 0) {
        params.tag = params.tag.join(",");
      }
      if (params && params.zone && params.zone.length > 0) {
        params.zone = params.zone.join(",");
      }

      if (params && params.status && params.status.length > 0) {
        params.status = params.status.join(",");
      }
      if (params && params.branch && params.branch.length > 0) {
        params.branch = params.branch.join(",");
      }

      this.$api[this.module]
        [this.method](params)
        .then((res) => {
          this.resetDownloadForm();
          if (res && res.data) {
            downloadBlob(res.data, `${returnToday()} ${this.title}`, ".xlsx");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style></style>
